module.exports = __webpack_public_path__ + "static/media/DSC_6232-HDR.b5ff5216.jpg";